interface LinkProps {
  href: string;
  target: "_blank" | "_self" | "_parent" | "_top";
  size?: "sm" | "md" | "lg";
  type?: "primary" | "secondary" | "tertiary" | "quaternary";
  text: string;
  onClick?: () => void;
}

const Link = ({
  href,
  target,
  text,
  size = "md",
  type = "primary",
  onClick,
}: LinkProps) => {
  let linkClasses = "";

  if (size === "sm") {
    linkClasses += "lc-px-6 lc-text-lg lc-h-[40px] lc-text-base lc-w-fit";
  } else if (size === "md") {
    linkClasses +=
      "lc-px-6 md:lc-px-10 lc-h-[40px] lc-w-[130px] md:lc-h-[48px] md:lc-w-[176px] lc-text-sm md:lc-text-base";
  } else if (size === "lg") {
    linkClasses +=
      "lc-px-6 md:lc-px-10 lc-h-[40px] lc-w-[130px] md:lc-h-[53px] md:lc-w-[215px] lc-text-sm md:lc-text-xl";
  }

  if (type === "primary") {
    linkClasses +=
      " lc-gap-3 lc-bg-cfa-blue-500 hover:lc-brightness-90 disabled:lc-brightness-100 lc-rounded-[100px] lc-text-white !lc-no-underline";
  } else if (type === "secondary") {
    linkClasses +=
      " !lc-px-0 hover:lc-underline hover:lc-underline-offset-4 !lc-w-fit lc-gap-4 lc-text-white !lc-no-underline";
  } else if (type === "tertiary") {
    linkClasses +=
      " hover:lc-bg-white hover:lc-text-black lc-border lc-border-white lc-border-solid lc-rounded-[100px] lc-text-white !lc-no-underline";
  } else if (type === "quaternary") {
    linkClasses +=
      " !lc-px-0 lc-underline lc-underline-offset-4 !lc-w-fit lc-gap-4 lc-text-white";
  }

  return (
    <a
      href={href}
      target={target}
      onClick={onClick}
      className={`lc-flex lc-items-center hover:lc-transition-all hover:lc-ease-in hover:lc-duration-200 lc-justify-center ${linkClasses} lc-font-azo-sans lc-font-medium lc-leading-none`}
    >
      {text}
    </a>
  );
};

export default Link;
